import React from 'react';
import { Row } from 'react-bootstrap';
import NeedsAnalysisButton from '../../Tools/NeedsAnalysis/NeedsAnalysisButton';
import './HelpMeDecide.scss';

export default function HelpMeDecide(props) {

  return (
    <div className="help-me-decide justify-content-center py-3">
      <Row className="justify-content-center">
        <h3 className="m-3 text-center">{props.title}</h3>
      </Row>
      <Row className="justify-content-center">
        <NeedsAnalysisButton title={props.subTitle} isFromHomePage={true} enablePolicyReview={props.enablePolicyReview} icon={props.icon}/>
      </Row>
    </div>
  );
}
